module.exports = {
  appName: 'NF ProFleet',
  calendarColor: 'blue',
  globalSupportEmail: 'profleet@nffleet.com',
  footerLogo: false,
  favicon: 'favicon-nf.svg',
  themeColor: '#0413a2',
}
